// ProtectedLayout.jsx
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom';

const ProtectedLayout = () => {
  const navigate = useNavigate();
  const { isLogged } = useStateContext();

  useEffect(() => {
    if (!isLogged) {
      navigate('/Login');
    }
  }, [isLogged, navigate]);

  return isLogged ? <Outlet /> : null;
};

export default ProtectedLayout;
